import { useAppSelector } from '@/state/store';
import { profileHasOnboarded } from '@/utils/profile';
import WorldIntro from '@/components/WorldIntro';

export default function LocationLayout({ children }: { children: React.ReactNode }) {
    return <WorldIntro>{children}</WorldIntro>;
}
